import React, { useEffect } from 'react';
import Chart from '../../../util/chart';

const DealQuotesPie = ({ quotes }) => {
  const createChart = () => {
    const dataProvider = [];

    quotes.forEach(data => {
      dataProvider.push({ label: `Q${data.id} (${data.QuoteState.name})`, value: 1, color: data.QuoteState.color });
    });

    Chart.makePieChart('quote-status-pie', {
      colorField: 'color',
      dataProvider,
      labelsEnabled: false,
    });
  };

  useEffect(() => {
    // TODO Might have scaling issues
    createChart();
  });

  return <div id="quote-status-pie" className="stretch" style={{ height: '200px' }} />;
};

export default DealQuotesPie;
